import { useCallback } from "react";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { deleteManyLessons } from "api/services/lesson-service";

export const useDeleteManyLessons = () => {
    const { callAPI, loading } = useWorkspaceApiCall(deleteManyLessons, 'deleteManyLessons.success', 'deleteManyLessons.error');

    const deleteLessonsMethod = useCallback(async (lessonIds: string[]) => {
        return await callAPI({ lessonIds });
    }, [callAPI]);

    return { deleteManyLessons: deleteLessonsMethod, deletingManyLessons: loading };
}